import { isServer } from "solid-js/web";

import { RouteConfig, RouteInfo } from "@/router";
import { useLocation } from "@solidjs/router";

export function isGameRoute() {
  const location = useLocation();
  console.log("[isGameRoute] location", location);
  return (
    location.pathname.includes("/game/") ||
    location.pathname.includes("/sports/") ||
    location.pathname.includes("/game-detail/")
  );
}

export function isSettingsRoute() {
  const location = useLocation();
  return location.pathname.includes("/settings");
}

export function isCasino() {
  return window.location.pathname.includes("/casino");
}

// 获取普通路由路径
export function normalizeRoutePath(fullPath: string): string {
  // 移除查询参数
  const pathWithout = fullPath.includes("?")
    ? fullPath.split("?")[0]
    : fullPath;

  // 移除语言前缀，例如 /en/, /zh/, /es/
  const pathWithoutLangPrefix = pathWithout.replace(
    /^\/[a-z]{2}(?:-[A-Z]{2})?\//,
    "/",
  );

  // 去除开头的斜杠
  return pathWithoutLangPrefix?.replace(/^\/+/, "") || "";
}

// 递归查找路由配置的 info 对象
export function findRouteInfo(routes: unknown[], pathname: string) {
  if (isServer) return undefined;
  const pathNameArr = pathname?.split("/").filter(Boolean);

  const findInRoutes = (
    routeList: unknown[],
    pathSegments: string[],
  ): RouteInfo | undefined => {
    for (const route of routeList as RouteConfig[]) {
      // 处理通配符路由
      if (route.path === "/*") {
        if (route.children && pathSegments.length > 0) {
          const result = findInRoutes(route.children, pathSegments);
          if (result) return result;
        }
        continue;
      }

      // 处理根路由
      if (route.path === "/") {
        if (route.children && pathSegments.length > 0) {
          const result = findInRoutes(route.children, pathSegments);
          if (result) return result;
        }
        continue;
      }

      // 检查当前路由是否匹配第一个路径段
      const routePath = route.path.startsWith("/")
        ? route.path.slice(1)
        : route.path;
      const routeSegments = routePath.split("/").filter(Boolean);

      if (routeSegments.length > 0 && routeSegments[0] === pathSegments[0]) {
        // 如果还有更多路径段，继续在子路由中查找
        if (pathSegments.length > 1 && route.children) {
          const result = findInRoutes(route.children, pathSegments.slice(1));
          if (result) return result;
        } else if (pathSegments.length === 1) {
          // 完全匹配，返回当前路由的 info
          return route.info;
        }
      }

      // 处理动态参数路由（如 :gid）
      if (routeSegments.length > 0 && routeSegments[0].startsWith(":")) {
        if (pathSegments.length > 1 && route.children) {
          const result = findInRoutes(route.children, pathSegments.slice(1));
          if (result) return result;
        } else if (pathSegments.length === 1) {
          return route.info;
        }
      }

      // 递归检查子路由
      if (route.children) {
        const result = findInRoutes(route.children, pathSegments);
        if (result) return result;
      }
    }
    return undefined;
  };

  return findInRoutes(routes, pathNameArr);
}
